import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { safeLocalStorage } from "@/lib/safeStorage";

interface LoginState {
  isLoggedIn: boolean;
  authReady: boolean;
  accessToken: string | null;
  refreshToken: string | null;
  firebaseToken: string | null;
}

const initialState: LoginState = {
  isLoggedIn: false,
  authReady: false,
  accessToken: null,
  refreshToken: null,
  firebaseToken: null,
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    login: (
      state,
      action: PayloadAction<{
        accessToken: string;
        refreshToken: string;
        firebaseToken?: string | null;
      }>
    ) => {
      state.isLoggedIn = true;
      state.authReady = true;
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      safeLocalStorage.setItem("accessToken", action.payload.accessToken);
      safeLocalStorage.setItem("refreshToken", action.payload.refreshToken);
      if (action.payload.firebaseToken) {
        state.firebaseToken = action.payload.firebaseToken;
        safeLocalStorage.setItem("firebaseToken", action.payload.firebaseToken);
      } else {
        state.firebaseToken = null;
        safeLocalStorage.removeItem("firebaseToken");
      }
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.authReady = true;
      state.accessToken = null;
      state.refreshToken = null;
      state.firebaseToken = null;
      safeLocalStorage.removeItem("accessToken");
      safeLocalStorage.removeItem("refreshToken");
      safeLocalStorage.removeItem("firebaseToken");
    },
    refreshToken: (
      state,
      action: PayloadAction<{
        accessToken: string;
        refreshToken: string;
        firebaseToken?: string | null;
      }>
    ) => {
      state.isLoggedIn = true;
      state.authReady = true;
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      safeLocalStorage.setItem("accessToken", action.payload.accessToken);
      safeLocalStorage.setItem("refreshToken", action.payload.refreshToken);
      if (action.payload.firebaseToken !== undefined) {
        state.firebaseToken = action.payload.firebaseToken;
        if (action.payload.firebaseToken) {
          safeLocalStorage.setItem("firebaseToken", action.payload.firebaseToken);
        } else {
          safeLocalStorage.removeItem("firebaseToken");
        }
      }
    },
    setTokensFromStorage: (state) => {
      if (typeof window !== "undefined") {
        const accessToken = safeLocalStorage.getItem("accessToken");
        const refreshToken = safeLocalStorage.getItem("refreshToken");
        const firebaseToken = safeLocalStorage.getItem("firebaseToken");
        if (accessToken && refreshToken) {
          state.isLoggedIn = true;
          state.accessToken = accessToken;
          state.refreshToken = refreshToken;
          state.firebaseToken = firebaseToken || null;
        }
      }
    },
    setAuthReady: (state, action: PayloadAction<boolean>) => {
      state.authReady = action.payload;
    },
  },
});

export const { login, logout, refreshToken, setTokensFromStorage, setAuthReady } =
  loginSlice.actions;
export default loginSlice.reducer;
